// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__fzBLY","change-color-on-hover":"BookNowBtn_change-color-on-hover__6UVF5","button":"BookNowBtn_button__2ayOO"};